import { render, staticRenderFns } from "./SlotNumber.vue?vue&type=template&id=466efe46&"
import script from "./SlotNumber.vue?vue&type=script&lang=js&"
export * from "./SlotNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports